import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Helpers from 'helpers'

export class RichText extends React.PureComponent<RichText.Props, RichText.State> {
  public static sectionId = 'richtex';

  public render(): JSX.Element {
    const { settings } = this.props.section
    const { section } = this.props.data

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = section?.article?.settings?.allow_full_width_images


    let padding = this.props.data.template.name === 'page' ? 'pb-4' : 'pb-2-4'
    let alignment = 'text-left'
    let backgroundColor = ''

    if (settings.padding) {
      switch (settings.padding) {
      case '0':
        break
      case '2':
        padding = 'py-2'
        break
      case '4':
        padding = 'py-4'
        break
      case '6':
        padding = 'py-6'
        break
      case '8':
        padding = 'py-8'
        break
      case '10':
        padding = 'py-10'
        break
      case '12':
        padding = 'py-12'
        break
      case '14':
        padding = 'py-14'
        break
      case '16':
        padding = 'py-16'
        break
      case '18':
        padding = 'py-18'
        break
      case '20':
        padding = 'py-20'
        break
      case '22':
        padding = 'py-22'
        break
      case '24':
        padding = 'py-24'
        break
      }
    }
    
    if (settings.alignment) {
      switch (settings.alignment) {
      case 'left':
        alignment = 'text-left'
        break
      case 'center':
        alignment = 'text-center'
        break
      case 'right':
        alignment = 'text-right'
        break
      }
    }
    
    if (settings.backgroundColor) {
      backgroundColor = ' bg-core-pale'
    }

    return (
      <section 
        className={`dynamic-richtext ${backgroundColor} ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}
      >
        <div
          style={{
            maxWidth: settings.maxwidth ? settings.maxwidth : '',
          }} 
          className={`dynamic-richtext ${padding} w-full md:w-5/6 mx-auto`}
        >
          <div className={'richtext richtext-link w-full md:w-4/5 px-1-6 md:px-0-4 mx-auto flex flex-wrap text-base leading-close'}>
            {Helpers.check(settings, 'settings.content') && (
              <div className={`w-full ${alignment}`}
                dangerouslySetInnerHTML={{
                  __html: settings.content,
                }}
              />
            )}
          </div>
        </div>
        <style>
          {
            `.richtext ol {
              list-style-type: decimal;
              padding-left: 1.5rem;
            }
            .richtext ol li {
              margin-bottom: 8px;
            }
            .richtext ol br {
              display: none;
            }
            
            @media screen and (min-width: 768px) {
              .richtext ol {
                padding-left: 2.5rem;
              }
            }`
          }
        </style>
      </section>
    )
  }

}

export namespace RichText {
  export interface Options extends ShopifyNext.Section {
    content: string;
  }
  export interface Props extends GlobalProps {
    section: RichText.Options;
  }
  export interface State { }
}
